import { useState } from "react";
import { Send } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, formatError } from "@/lib/api";
import { waPhone } from "@/lib/whatsapp";

const NOMI = { scheda: "della tua scheda di lavoro", contratto: "del tuo contratto di noleggio", privacy: "del modulo privacy", preventivo: "del preventivo di riparazione" };

export const CondividiButton = ({ tipo, id, telefono, nome, numero, firmato, negozio, label, testId, size }) => {
  const [busy, setBusy] = useState(false);
  const click = async () => {
    if (!telefono) return toast.error("Il cliente non ha un numero di telefono");
    const w = window.open("", "_blank");
    setBusy(true);
    try {
      const { data } = await api.post("/condividi", { tipo, id });
      const link = `${window.location.origin}/documento/${data.token}`;
      const text = `Ciao ${(nome || "").split(" ")[0]}, ecco la copia ${NOMI[tipo]}${numero ? ` ${numero}` : ""}${firmato ? " firmato" : ""}: ${link}${negozio ? `\n${negozio}` : ""}`;
      const url = `https://wa.me/${waPhone(telefono)}?text=${encodeURIComponent(text)}`;
      if (w) w.location.href = url;
      else window.open(url, "_blank", "noopener");
    } catch (e) {
      if (w) w.close();
      toast.error(formatError(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Button variant="outline" size={size} onClick={click} disabled={busy} data-testid={testId || `condividi-${tipo}-button`}
      className="border-emerald-300 bg-emerald-50 text-emerald-700 hover:bg-emerald-100 hover:text-emerald-800">
      <Send className="mr-1 h-4 w-4" /> {label || (firmato ? "Invia documento firmato" : "Invia documento")}
    </Button>
  );
};
